import React from 'react';
import T from 'prop-types';

import { Container } from './style';

const Icon = ({ symbol }) => <Container symbol={symbol} />;

Icon.propTypes = {
  symbol: T.string.isRequired,
};

export default Icon;
